import {
  CmmFilterKeys,
  FormPickedValues,
  StatusValues,
} from "../../../enums/cmmFilterKeys";
import { PocAssignee, PocAssigneeLabels } from "../../../enums/pocAssignee";

/** Sentinel value the CMM orders API uses for rows with no POC assigned. */
export const UNASSIGNED_POC = "unassigned";

const allPocOptions = Object.values(PocAssignee).map((assignee) => ({
  label: PocAssigneeLabels[assignee],
  value: assignee,
}));

export const createFilterForInsuranceCardDate = () => {
  return {
    id: CmmFilterKeys.DateOfFiling,
    label: "Date of Filing",
    options: [],
    type: "date" as const,
  };
};

export const createFilterForCmmStatus = () => {
  return {
    id: CmmFilterKeys.CmmStatus,
    label: "CMM Status",
    options: [
      {
        label: "Form Filled",
        value: StatusValues.FormFilled,
      },
      {
        label: "Sent to plan",
        value: StatusValues.SentToPlan,
      },
      {
        label: "QA Fetched",
        value: StatusValues.QaFetched,
      },
      {
        label: "Inaccuracy",
        value: StatusValues.Inaccuracy,
      },
      {
        label: "Form Error",
        value: StatusValues.FormError,
      },
    ],
    type: "string" as const,
  };
};

export const createFilterForFormPickedVia = () => {
  return {
    id: CmmFilterKeys.FormPickedVia,
    label: "Form Picked Via",
    options: [
      {
        label: "Rx Details 25",
        value: FormPickedValues.RxDetails25,
      },
      {
        label: "Rx Details 24",
        value: FormPickedValues.RxDetails24,
      },
      {
        label: "PBM",
        value: FormPickedValues.Pbm,
      },
    ],
    type: "string" as const,
  };
};

/** Builds the POC multi-select filter for the CMM orders table. */
export const createFilterForPoc = () => {
  return {
    id: CmmFilterKeys.Poc,
    label: "POC",
    options: [
      { label: "Unassigned", value: UNASSIGNED_POC },
      ...allPocOptions,
    ],
    type: "string" as const,
  };
};
